import { router } from "@inertiajs/react";
import type { Subscription } from "@rails/actioncable";
import { useEffect, useRef } from "react";
import { getConsumer } from "@/lib/cable";

interface ExtractionChannelMessage {
  event: "extraction.updated";
  extraction_id: number;
}

export function useProgramExtractionChannel(programId: number, enabled: boolean): void {
  const subscriptionRef = useRef<Subscription | null>(null);

  useEffect(() => {
    if (!enabled) return;

    subscriptionRef.current = getConsumer().subscriptions.create(
      { channel: "Programs::ExtractionChannel", program_id: programId },
      {
        // Reload on (re)connect as well as on each broadcast: a terminal
        // status change emitted before this subscription was established (fast
        // job, slow socket) is never re-sent, so without this the panel can
        // sit on a stale running state. Reloading on connect resyncs from the
        // server on initial subscribe and after any reconnect.
        connected() {
          router.reload({ only: ["program"] });
        },
        received(_data: ExtractionChannelMessage) {
          router.reload({ only: ["program"] });
        },
      },
    );

    return () => {
      subscriptionRef.current?.unsubscribe();
      subscriptionRef.current = null;
    };
  }, [programId, enabled]);
}
